import { UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import * as Types from '@/types/bff/gql-schema';

import { useGetDoctorReviewQuery } from './doctor.gql.impl';

const useGetDoctorReviewInfinityQuery = <TData = Types.GetDoctorReviewQuery, TError = unknown>(
  variables: Types.GetDoctorReviewQueryVariables,
  options?: UseInfiniteQueryOptions<Types.GetDoctorReviewQuery, TError, TData>
) => {
  return useInfiniteQuery<Types.GetDoctorReviewQuery, TError, TData>(
    ['DoctorReview', variables],
    ({ pageParam }: { pageParam?: number }) => {
      return useGetDoctorReviewQuery.fetcher({
        ...variables,
        pagingRequest: {
          ...variables.pagingRequest,
          page: pageParam || 1,
        },
      })();
    },
    {
      ...options,
      getNextPageParam: (lastPage: Types.GetDoctorReviewQuery, allPages: Types.GetDoctorReviewQuery[]) => {
        const size = variables.pagingRequest.limit as number;
        if (lastPage.doctorReview.length < size) {
          return undefined;
        }

        const allReview = allPages.reduce((sum, cur) => sum + cur.doctorReview.length, 0);
        const nextPage = Number(allReview / size) + 1;

        return nextPage;
      },
    }
  );
};
useGetDoctorReviewInfinityQuery.getKey = (variables: Types.GetDoctorReviewQueryVariables) => [
  'DoctorReview',
  variables,
];
export default useGetDoctorReviewInfinityQuery;
